
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class QualityDescriptionModal extends Vue {
  visible = false;
  init() {
    this.visible = true;
  }

  handleOk() {
    this.visible = false;
  }

  handleCancel() {
    this.visible = false;
  }
}
